import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueResource from "vue-resource"
import ElementUI from 'element-ui';
import locale from "element-ui/lib/locale/lang/en"
import 'element-ui/lib/theme-chalk/index.css';
import settings from "./backend/LocalSettings";
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'sweetalert2/dist/sweetalert2.min.css'



var currencyFormatter = require('currency-formatter');

Vue.config.productionTip = false

Vue.use(ElementUI, { locale });
Vue.use(VueResource);
Vue.use(BootstrapVue);



Vue.http.options.xhr = { withCredentials: true };
Vue.http.options.emulateJSON = true;
Vue.http.headers.common["Token"] = settings.get_token();

Vue.http.options.root = settings.BASE_URL;


Vue.filter( 'money_format', function(value){
  return currencyFormatter.format(value, {
      symbol: '',
      decimal: ',',
      thousand: '.',
      precision: 2,
      format: '%v'
    });
} );

function isJSON(str) {
  try {
      return (JSON.parse(str) && !!str);
  } catch (e) {
      return false;
  }
}

Vue.filter( 'translate_in_default_language', function(value){
  if( isJSON(value)){
    var _values   = JSON.parse(value);
    var lang      = settings.get_default_language();
    
    var ret    = "";
    if( value == "" ) return ret;
    
    var filtered = _values.filter( x => x.Lang == lang );
    if( filtered.length > 0 ){
        ret = filtered[0].Valoare;
    }
    return ret;
  } else {
    return value;
  }
} );

Vue.filter( 'translate_in_ro', function(value){
  if( isJSON(value)){
    var _values   = JSON.parse(value);
    var lang      = "RO";
    
    var ret    = "";
    if( value == "" ) return ret;
    
    var filtered = _values.filter( x => x.Lang == lang );
    if( filtered.length > 0 ){
        ret = filtered[0].Valoare;
    }
    return ret;
  } else {
    return value;
  }
} );

var app = new Vue({
  router,
  store,
  render: h => h(App)
});



app.$mount('#app');
